import { useEffect, useState } from "react";
import { getTotalUsers, getTotalValidators, getUsers } from "../../apis/AdminDashboard/users";
import SideBar from "../../components/AdminDashboard/SideBar";
import "../../styles/AdminDashboard/Users.scss";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Search from "../../components/AdminDashboard/Search";
const Users = () => {
  const auth = useSelector((state) => state.auth);

  const navigate = useNavigate();

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [userType, setUserType] = useState("basic");
  const [totalBasicUsers, setTotalBasicUsers] = useState(0);
  const [totalGovernanceUsers, setTotalGovernanceUsers] = useState(0);
  const [totalBusinessUsers, setTotalBusinessUsers] = useState(0);

  const listUsers = async () => {
    setLoading(true);
    const response = await getUsers(userType, auth?.token);
    console.log("response really", response);
    // const filteredUsers = response?.data?.users?.filter(
    //   (user) => user?.user === "user" && user?.role === "user"
    // );
    setUsers(response?.data?.users?.reverse());
    setLoading(false);
  };

  useEffect(() => {
    if(!!userType) {
      listUsers();
    }
  }, [userType]);

  const getAllUsers = async () => {
    const responseBasic = await getUsers("basic", auth?.token);
    const responseGovernance = await getUsers("governance", auth?.token);
    const responseBusiness = await getUsers("business", auth?.token);
    setTotalBasicUsers(responseBasic?.data?.users?.length);
    setTotalGovernanceUsers(responseGovernance?.data?.users?.length);
    setTotalBusinessUsers(responseBusiness?.data?.users?.length);
  };

  useEffect(() => {
    getAllUsers();
  }, [])


  return (
    <div className="admin_users">
      <div className="sidebar_container">
        <SideBar />
      </div>

      <div className="main">
        <Search />
        <div className="title">Users</div>
        <div className="subtitle">Users summary</div>
        <div className="users-admin_card_group">
          <div className="card">
            <div className="title">Basic</div>
            <div className="value_group">
              <div className="value">{totalBasicUsers}</div>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.9714 19.6874C20.686 17.4315 18.679 15.6737 16.2733 14.6971C17.4696 13.7998 18.3533 12.5489 18.7992 11.1215C19.2451 9.69412 19.2305 8.16262 18.7576 6.74395C18.2847 5.32527 17.3775 4.09135 16.1643 3.21697C14.9512 2.34259 13.4937 1.87207 11.9983 1.87207C10.5029 1.87207 9.04535 2.34259 7.83221 3.21697C6.61907 4.09135 5.71179 5.32527 5.2389 6.74395C4.76601 8.16262 4.75148 9.69412 5.19736 11.1215C5.64325 12.5489 6.52694 13.7998 7.72327 14.6971C5.31757 15.6737 3.3105 17.4315 2.02515 19.6874C1.9455 19.8154 1.89242 19.9582 1.86905 20.1072C1.84569 20.2562 1.85252 20.4084 1.88914 20.5547C1.92575 20.701 1.99141 20.8384 2.08221 20.9588C2.17301 21.0792 2.28709 21.1802 2.41767 21.2556C2.54826 21.3311 2.69268 21.3795 2.84235 21.398C2.99202 21.4165 3.14388 21.4047 3.28891 21.3634C3.43395 21.322 3.56918 21.252 3.68659 21.1573C3.80399 21.0626 3.90117 20.9453 3.97233 20.8124C5.67108 17.8761 8.67108 16.1249 11.9983 16.1249C15.3255 16.1249 18.3255 17.8771 20.0242 20.8124C20.1784 21.0604 20.4231 21.2387 20.7064 21.3096C20.9897 21.3805 21.2895 21.3385 21.5423 21.1924C21.7952 21.0463 21.9814 20.8076 22.0614 20.5267C22.1415 20.2458 22.1092 19.9449 21.9714 19.6874ZM7.12327 8.99988C7.12327 8.0357 7.40919 7.09317 7.94486 6.29148C8.48053 5.48979 9.2419 4.86495 10.1327 4.49597C11.0235 4.12699 12.0037 4.03045 12.9493 4.21855C13.895 4.40666 14.7636 4.87096 15.4454 5.55274C16.1272 6.23452 16.5915 7.10316 16.7796 8.04882C16.9677 8.99447 16.8712 9.97467 16.5022 10.8655C16.1332 11.7563 15.5084 12.5176 14.7067 13.0533C13.905 13.589 12.9625 13.8749 11.9983 13.8749C10.7058 13.8734 9.46669 13.3593 8.55277 12.4454C7.63885 11.5315 7.12476 10.2924 7.12327 8.99988Z"
                  fill="#00AED9"
                />
              </svg>
            </div>
          </div>
          <div className="card">
            <div className="title">Governance</div>
            <div className="value_group">
              <div className="value">{totalGovernanceUsers}</div>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.2971 15.4246C15.4005 14.5571 16.206 13.3672 16.6016 12.0205C16.9972 10.6738 16.9631 9.2373 16.5041 7.91087C16.0451 6.58445 15.1841 5.4341 14.0408 4.61991C12.8975 3.80571 11.5288 3.36816 10.1252 3.36816C8.72163 3.36816 7.35295 3.80571 6.20965 4.61991C5.06635 5.4341 4.2053 6.58445 3.74632 7.91087C3.28733 9.2373 3.25326 10.6738 3.64883 12.0205C4.04439 13.3672 4.84993 14.5571 5.95334 15.4246C4.17892 16.1487 2.6109 17.3 1.38865 18.7761C1.1967 19.0046 1.10339 19.3 1.12923 19.5973C1.15508 19.8946 1.29797 20.1695 1.52647 20.3614C1.75497 20.5534 2.05036 20.6467 2.34766 20.6209C2.64497 20.595 2.91983 20.4521 3.11178 20.2236C4.39522 18.6955 6.65647 16.8749 10.1252 16.8749C13.594 16.8749 15.8552 18.6955 17.1387 20.2236C17.3306 20.4521 17.6055 20.595 17.9028 20.6209C18.2001 20.6467 18.4955 20.5534 18.724 20.3614C18.9525 20.1695 19.0954 19.8946 19.1212 19.5973C19.147 19.3 19.0537 19.0046 18.8618 18.7761C17.6398 17.2998 16.0717 16.1484 14.2971 15.4246ZM5.62522 10.1249C5.62522 9.23487 5.88914 8.36484 6.3836 7.62482C6.87807 6.8848 7.58087 6.30802 8.40314 5.96743C9.22541 5.62683 10.1302 5.53772 11.0031 5.71135C11.876 5.88498 12.6779 6.31357 13.3072 6.9429C13.9365 7.57224 14.3651 8.37406 14.5387 9.24698C14.7124 10.1199 14.6233 11.0247 14.2827 11.847C13.9421 12.6692 13.3653 13.372 12.6253 13.8665C11.8853 14.361 11.0152 14.6249 10.1252 14.6249C8.93212 14.6236 7.78825 14.1491 6.94461 13.3055C6.10096 12.4618 5.62646 11.318 5.62522 10.1249ZM23.6252 10.1249C23.6287 11.9533 23.2583 13.7632 22.5368 15.4433C22.4854 15.5885 22.4048 15.7216 22.2999 15.8343C22.195 15.9471 22.0681 16.0371 21.927 16.0988C21.7859 16.1605 21.6337 16.1926 21.4797 16.1931C21.3257 16.1936 21.1733 16.1624 21.0318 16.1016C20.8903 16.0408 20.7629 15.9515 20.6573 15.8394C20.5517 15.7273 20.4702 15.5948 20.418 15.4499C20.3657 15.3051 20.3437 15.151 20.3534 14.9973C20.3631 14.8437 20.4042 14.6936 20.4743 14.5564C21.0719 13.1554 21.3799 11.648 21.3799 10.1249C21.3799 8.60174 21.0719 7.09433 20.4743 5.69332C20.4042 5.55618 20.3631 5.40612 20.3534 5.25243C20.3437 5.09874 20.3657 4.94471 20.418 4.79985C20.4702 4.655 20.5517 4.52243 20.6573 4.41033C20.7629 4.29824 20.8903 4.20901 21.0318 4.14818C21.1733 4.08735 21.3257 4.05621 21.4797 4.05669C21.6337 4.05717 21.7859 4.08925 21.927 4.15096C22.0681 4.21267 22.195 4.30269 22.2999 4.41544C22.4048 4.52819 22.4854 4.66127 22.5368 4.80645C23.2583 6.48655 23.6287 8.29642 23.6252 10.1249ZM19.4065 6.07113C19.9636 7.34998 20.2512 8.72994 20.2512 10.1249C20.2512 11.5198 19.9636 12.8998 19.4065 14.1786C19.2869 14.4521 19.0635 14.6669 18.7856 14.7758C18.5076 14.8846 18.1978 14.8785 17.9243 14.7589C17.6508 14.6393 17.436 14.416 17.3272 14.138C17.2183 13.8601 17.2244 13.5503 17.344 13.2768C17.7762 12.2822 17.9992 11.2093 17.9992 10.1249C17.9992 9.04044 17.7762 7.96759 17.344 6.97301C17.2244 6.6995 17.2183 6.38969 17.3272 6.11173C17.436 5.83376 17.6508 5.61042 17.9243 5.49082C18.1978 5.37123 18.5076 5.36518 18.7856 5.47401C19.0635 5.58284 19.2869 5.79763 19.4065 6.07113Z"
                  fill="#00AED9"
                />
              </svg>
            </div>
          </div>
          <div className="card">
            <div className="title">Business</div>
            <div className="value_group">
              <div className="value">{totalBusinessUsers}</div>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.2971 15.4246C15.4005 14.5571 16.206 13.3672 16.6016 12.0205C16.9972 10.6738 16.9631 9.2373 16.5041 7.91087C16.0451 6.58445 15.1841 5.4341 14.0408 4.61991C12.8975 3.80571 11.5288 3.36816 10.1252 3.36816C8.72163 3.36816 7.35295 3.80571 6.20965 4.61991C5.06635 5.4341 4.2053 6.58445 3.74632 7.91087C3.28733 9.2373 3.25326 10.6738 3.64883 12.0205C4.04439 13.3672 4.84993 14.5571 5.95334 15.4246C4.17892 16.1487 2.6109 17.3 1.38865 18.7761C1.1967 19.0046 1.10339 19.3 1.12923 19.5973C1.15508 19.8946 1.29797 20.1695 1.52647 20.3614C1.75497 20.5534 2.05036 20.6467 2.34766 20.6209C2.64497 20.595 2.91983 20.4521 3.11178 20.2236C4.39522 18.6955 6.65647 16.8749 10.1252 16.8749C13.594 16.8749 15.8552 18.6955 17.1387 20.2236C17.3306 20.4521 17.6055 20.595 17.9028 20.6209C18.2001 20.6467 18.4955 20.5534 18.724 20.3614C18.9525 20.1695 19.0954 19.8946 19.1212 19.5973C19.147 19.3 19.0537 19.0046 18.8618 18.7761C17.6398 17.2998 16.0717 16.1484 14.2971 15.4246ZM5.62522 10.1249C5.62522 9.23487 5.88914 8.36484 6.3836 7.62482C6.87807 6.8848 7.58087 6.30802 8.40314 5.96743C9.22541 5.62683 10.1302 5.53772 11.0031 5.71135C11.876 5.88498 12.6779 6.31357 13.3072 6.9429C13.9365 7.57224 14.3651 8.37406 14.5387 9.24698C14.7124 10.1199 14.6233 11.0247 14.2827 11.847C13.9421 12.6692 13.3653 13.372 12.6253 13.8665C11.8853 14.361 11.0152 14.6249 10.1252 14.6249C8.93212 14.6236 7.78825 14.1491 6.94461 13.3055C6.10096 12.4618 5.62646 11.318 5.62522 10.1249ZM23.6252 10.1249C23.6287 11.9533 23.2583 13.7632 22.5368 15.4433C22.4854 15.5885 22.4048 15.7216 22.2999 15.8343C22.195 15.9471 22.0681 16.0371 21.927 16.0988C21.7859 16.1605 21.6337 16.1926 21.4797 16.1931C21.3257 16.1936 21.1733 16.1624 21.0318 16.1016C20.8903 16.0408 20.7629 15.9515 20.6573 15.8394C20.5517 15.7273 20.4702 15.5948 20.418 15.4499C20.3657 15.3051 20.3437 15.151 20.3534 14.9973C20.3631 14.8437 20.4042 14.6936 20.4743 14.5564C21.0719 13.1554 21.3799 11.648 21.3799 10.1249C21.3799 8.60174 21.0719 7.09433 20.4743 5.69332C20.4042 5.55618 20.3631 5.40612 20.3534 5.25243C20.3437 5.09874 20.3657 4.94471 20.418 4.79985C20.4702 4.655 20.5517 4.52243 20.6573 4.41033C20.7629 4.29824 20.8903 4.20901 21.0318 4.14818C21.1733 4.08735 21.3257 4.05621 21.4797 4.05669C21.6337 4.05717 21.7859 4.08925 21.927 4.15096C22.0681 4.21267 22.195 4.30269 22.2999 4.41544C22.4048 4.52819 22.4854 4.66127 22.5368 4.80645C23.2583 6.48655 23.6287 8.29642 23.6252 10.1249ZM19.4065 6.07113C19.9636 7.34998 20.2512 8.72994 20.2512 10.1249C20.2512 11.5198 19.9636 12.8998 19.4065 14.1786C19.2869 14.4521 19.0635 14.6669 18.7856 14.7758C18.5076 14.8846 18.1978 14.8785 17.9243 14.7589C17.6508 14.6393 17.436 14.416 17.3272 14.138C17.2183 13.8601 17.2244 13.5503 17.344 13.2768C17.7762 12.2822 17.9992 11.2093 17.9992 10.1249C17.9992 9.04044 17.7762 7.96759 17.344 6.97301C17.2244 6.6995 17.2183 6.38969 17.3272 6.11173C17.436 5.83376 17.6508 5.61042 17.9243 5.49082C18.1978 5.37123 18.5076 5.36518 18.7856 5.47401C19.0635 5.58284 19.2869 5.79763 19.4065 6.07113Z"
                  fill="#00AED9"
                />
              </svg>
            </div>
          </div>
        </div>

        <div className="users-table">
          <div className="users-table__header">
            <div>
              <button className={userType === "basic" && "active"}
              onClick={() => setUserType("basic")}
              >Basic</button>
              {!userType && <div></div>}
              <button
              className={userType === "governance" && "active"}
              onClick={() => setUserType("governance")}
              >Governance</button>
              <button
              className={userType === "business" && "active"}
              onClick={() => setUserType("business")}
              >Business</button>
            </div>
            <div>
            <button
              className={!userType && "active"}
              onClick={() => setUserType(null)}
              >View all</button>
            </div>
          </div>

          <div className="users-table__label">
            <div>Email</div>
            <div>Company Name</div>
            <div>Contact</div>
            <div>CO2 tracked</div>
            <div>CO2 offset</div>
            <div>CO2 credit</div>
          </div>
{loading &&
<>
<div
                className="users-table__item"
              > <Skeleton width="60%" height={15} borderRadius={4} />
              <Skeleton width="60%" height={15} borderRadius={4} />
              <Skeleton width="60%" height={15} borderRadius={4} />
              <Skeleton width="60%" height={15} borderRadius={4} />
              <Skeleton width="60%" height={15} borderRadius={4} />
              <Skeleton width="60%" height={15} borderRadius={4} />

                </div>
<div
                className="users-table__item"
              > <Skeleton width="60%" height={15} borderRadius={4} />
              <Skeleton width="60%" height={15} borderRadius={4} />
              <Skeleton width="60%" height={15} borderRadius={4} />
              <Skeleton width="60%" height={15} borderRadius={4} />
              <Skeleton width="60%" height={15} borderRadius={4} />
              <Skeleton width="60%" height={15} borderRadius={4} />

                </div>
<div
                className="users-table__item"
              > <Skeleton width="60%" height={15} borderRadius={4} />
              <Skeleton width="60%" height={15} borderRadius={4} />
              <Skeleton width="60%" height={15} borderRadius={4} />
              <Skeleton width="60%" height={15} borderRadius={4} />
              <Skeleton width="60%" height={15} borderRadius={4} />
              <Skeleton width="60%" height={15} borderRadius={4} />

                </div>
<div
                className="users-table__item"
              > <Skeleton width="60%" height={15} borderRadius={4} />
              <Skeleton width="60%" height={15} borderRadius={4} />
              <Skeleton width="60%" height={15} borderRadius={4} />
              <Skeleton width="60%" height={15} borderRadius={4} />
              <Skeleton width="60%" height={15} borderRadius={4} />
              <Skeleton width="60%" height={15} borderRadius={4} />

                </div>
</>
}
          
            {users?.map((user) => (
              <div
                className="users-table__item"
                onClick={() => navigate(`/admin/users/${user?.id}`)}
              >
                <div>{user?.email}</div>
                <div>{user?.companyName || user?.facilityName}</div>
                <div>
                  {user?.countryCode}
                  {user?.phoneNumber}
                </div>
                <div>{user?.va}tCO2</div>
                <div>{user?.totalOffset}tCO2</div>
                <div>{user?.totalOffset}</div>
              </div>
            ))}
        </div>

       
      </div>
    </div>
  );
};

export default Users;
